import {
  allSavedBlocksMap as allSavedBlocksMapAtom,
  customBlockCuboids as customBlockCuboidsAtom,
} from '@/components/Analysis/modules/CustomBlocks/state';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { DeckplanOverlayWorkscopeSvg } from './DeckplanOverlayWorkscopeSvg';
import { getPoiCoordinates } from '@/utils/pointOfInterest';
import { showWorkscopeOverlayIcons as showWorkscopeOverlayIconsAtom } from '@/components/Analysis/modules/CustomBlocks/state';

export const DeckplanOverlayWorkscopeMarkers = () => {
  const customBlockCuboids = useAtomValue(customBlockCuboidsAtom);
  const allSavedBlocksMap = useAtomValue(allSavedBlocksMapAtom);
  const showWorkscopeOverlayIcons = useAtomValue(showWorkscopeOverlayIconsAtom);

  const svgs = useMemo(() => {
    if (!showWorkscopeOverlayIcons) return [];
    return customBlockCuboids
      .map(({ id, position, scale }) => {
        const [x, y] = position;
        const cadTransform = allSavedBlocksMap.get(id)?.paintRegion?.deck?.cadTransform;
        if (!cadTransform) return undefined;
        const location = getPoiCoordinates({ x, y }, cadTransform);
        if (!location || !scale) {
          // TODO: Replace with Sentry logging
          console.warn('Workscope with no 3D data', id);
          return undefined;
        }
        return <DeckplanOverlayWorkscopeSvg scale={scale} location={location} />;
      })
      .filter((item) => item !== undefined);
  }, [allSavedBlocksMap, customBlockCuboids, showWorkscopeOverlayIcons]);

  return <>{svgs}</>;
};
